export default "__VITE_ASSET__58270d74__"